import React from "react";

import { CollapseHeader, FormCollapse } from "components/Form";
import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";
import { withNamespace } from "components/Form/FormikControls";
import {
  getActiveLivestockAgentDeployment,
  getIsLivestockAgent,
} from "selectors";
import { useSelector } from "react-redux";
import BankingDetailsForm from "./BankingDetailsForm";
import AbrDetailsForm from "./AbrDetailsForm";

interface BusinessGeneralFinanceSectionProps {
  sectionHelper: SectionToggleState;
  businessId: string | null;
  namespace: string;
  abn: string;
  abrLastChecked: string;
}

export const BusinessGeneralFinanceSection: React.FC<
  BusinessGeneralFinanceSectionProps
> = ({ sectionHelper, businessId, namespace, abn, abrLastChecked }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.GENERAL,
  );

  const header = <CollapseHeader title="General" />;
  const deployment = useSelector(getActiveLivestockAgentDeployment) || {};

  const { deploymentSettings } = deployment;
  const isLivestockAgent = useSelector(getIsLivestockAgent);

  const showBpay = isLivestockAgent && deploymentSettings?.bpayBillerCode;
  return (
    <FormCollapse isOpen={isOpen} onToggle={onToggle} header={header}>
      <BankingDetailsForm
        namespace={withNamespace(namespace, "bankingDetails")}
      />
      <AbrDetailsForm
        namespace={namespace}
        businessId={businessId}
        abn={abn}
        abrLastChecked={abrLastChecked}
        showBpay={showBpay}
      />
    </FormCollapse>
  );
};
